export default __webpack_public_path__ + "static/media/orca.54e0d992.jpg";